import { scrollToElement } from "../../../utils";

class PasswordRepetitionComponent {
    private readonly $passwordRepeatInputField: HTMLInputElement;
    private readonly $passwordRepeatInputFieldGroup: HTMLElement;
    private readonly $passwordInputField: HTMLInputElement;
    private readonly scrollDuration: number = 200;
    private readonly $formAlreadySubmitted: boolean;
    private $hidePasswordRepeatEmptyHint: boolean = true;

    constructor(document: Document, validateImmediately: boolean) {
        this.$passwordInputField = document.querySelector(".id_js_password_password")!!;
        this.$passwordRepeatInputField = document.querySelector(".js_password_repeatPassword")!!;
        this.$passwordRepeatInputFieldGroup = document.querySelector(".js_password_inputRepeatComponent")!!;
        this.$formAlreadySubmitted = validateImmediately;

        /*                                  */
        /*                      */
        if (!String.prototype.startsWith) {
            String.prototype.startsWith = function (searchString, position) {
                position = position || 0;
                return this.indexOf(searchString, position) === position;
            };
        }
    }

    registerEventListeners() {
        if (this.$passwordRepeatInputField && this.$passwordInputField) {
            this.registerPasswordDiffListeners();

            this.$passwordRepeatInputField.addEventListener("focusin", (ev) => {
                scrollToElement(ev.currentTarget as HTMLInputElement, this.scrollDuration);
            });
        }
    }

    registerPasswordDiffListeners() {
        if (this.$passwordRepeatInputField && this.$passwordInputField) {
            this.$passwordInputField.addEventListener("input", () => {
                if (this.$formAlreadySubmitted) {
                    this.$hidePasswordRepeatEmptyHint = false;
                }
                this.showWarningIfPasswordsDontMatch();
            });

            this.$passwordInputField.addEventListener("focusout", () => {
                if (this.$formAlreadySubmitted) {
                    this.$hidePasswordRepeatEmptyHint = false;
                }
                this.showWarningIfPasswordsDontMatch(false);
            });

            this.$passwordRepeatInputField.addEventListener("input", () => {
                this.$hidePasswordRepeatEmptyHint = true;
                this.showWarningIfPasswordsDontMatch();
            });

            this.$passwordRepeatInputField.addEventListener("focusout", () => {
                this.$hidePasswordRepeatEmptyHint = false;
                this.showWarningIfPasswordsDontMatch(false);
            });
        }
    }

    private showWarningIfPasswordsDontMatch(usingStartsWith: boolean = true) {
        const warningSpan = this.$passwordRepeatInputFieldGroup.querySelector(".js_password_repeatPassword_mismatch") as Element;
        const emptySpan = this.$passwordRepeatInputFieldGroup.querySelector(".js_password_repeatPassword_empty") as Element;

        const repeatFieldValue = this.$passwordRepeatInputField.value;
        const passwdFieldValue = this.$passwordInputField.value;
        const passwordFieldsDiffer = usingStartsWith ? !passwdFieldValue.startsWith(repeatFieldValue) : passwdFieldValue != repeatFieldValue;
        const bothFieldsFilled = passwdFieldValue.length > 0 && repeatFieldValue.length > 0;

        if (bothFieldsFilled && passwordFieldsDiffer) {
            warningSpan.classList.remove("invisible");
            emptySpan.classList.add("invisible");
            this.addErrorStyleToInputField();
        } else {
            warningSpan.classList.add("invisible");
            this.removeErrorStyleFromInputField();
            if (repeatFieldValue.length === 0) {
                emptySpan.classList.remove("invisible");
                this.addErrorStyleToInputField();
            }
            if (this.$hidePasswordRepeatEmptyHint) {
                emptySpan.classList.add("invisible");
                this.removeErrorStyleFromInputField();
            }
        }
    }

    private addErrorStyleToInputField() {
        this.$passwordRepeatInputFieldGroup.classList.add("pl_input--invalid");
    }

    private removeErrorStyleFromInputField() {
        this.$passwordRepeatInputFieldGroup.classList.remove("pl_input--invalid");
    }
}

export default PasswordRepetitionComponent;
